import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSofaDouble = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M20.25,19.875c-0.414,0-0.75-0.336-0.75-0.75v-1.5h-15v1.5c0,0.414-0.336,0.75-0.75,0.75S3,19.539,3,19.125v-1.577 c-1.732-0.35-3-1.874-3-3.673v-3C0,9.897,0.634,9.04,1.544,8.739C1.861,6.131,4.097,4.125,6.75,4.125h10.5 c2.653,0,4.889,2.006,5.206,4.614C23.366,9.04,24,9.897,24,10.875v3c0,1.799-1.268,3.323-3,3.673v1.577 C21,19.539,20.664,19.875,20.25,19.875z M2.25,10.125c-0.414,0-0.75,0.336-0.75,0.75v3c0,1.241,1.009,2.25,2.25,2.25h16.5 c1.241,0,2.25-1.009,2.25-2.25v-3c0-0.414-0.336-0.75-0.75-0.75S21,10.461,21,10.875v1.5c0,0.827-0.673,1.5-1.5,1.5h-15 c-0.827,0-1.5-0.673-1.5-1.5v-1.5C3,10.461,2.664,10.125,2.25,10.125z M19.5,12.375v-1.5c0-0.938,0.592-1.773,1.448-2.101 c-0.291-1.788-1.861-3.149-3.698-3.149h-4.5v6.75H19.5z M3.052,8.774C3.908,9.102,4.5,9.937,4.5,10.875v1.5h6.75v-6.75h-4.5 C4.913,5.625,3.343,6.985,3.052,8.774z" }) })
});
export default SvgSofaDouble;
